import { T } from "@/locales";

export default {
  username: [{ required: true, message: T("请输入用户名"), trigger: "change" }],
  name: [{ required: true, message: T("请输入姓名"), trigger: "change" }],
  phone: [{ max: 32, message: T("超出最大长度 (32)"), trigger: "change" }],
  email: [{ max: 256, message: T("超出最大长度 (256)"), trigger: "change" }],
  roles: [{ required: true, message: T("请选择角色"), trigger: "change" }],
};
